// VH-206: a machine candidate's display name.
/** The candidate's name in the user's language, English as the fallback. */
export function candidateName(candidate, language) {
  const lang = (language || 'en').split('-')[0]
  if (lang === 'de' && candidate?.name_de) return candidate.name_de
  return candidate?.name_en || ''
}
